import React from 'react';
import { initializeSubscriptionPlans } from '../firebase';
import './InitializePlans.css';

export default function InitializePlans() {
    const [status, setStatus] = React.useState('idle');
    const [message, setMessage] = React.useState('');

    const handleInitialize = async () => {
        setStatus('loading');
        setMessage('Inicializando planos...');

        try {
            await initializeSubscriptionPlans();
            setStatus('success');
            setMessage('✅ Planos inicializados com sucesso! Os 3 planos (Básico, Intermediário e Avançado) foram criados no Firebase.');
        } catch (error) {
            setStatus('error');
            setMessage(`❌ Erro ao inicializar planos: ${error.message}`);
        }
    };

    return (
        <div className="initialize-plans-container">
            <div className="initialize-card">
                <h2>🚀 Inicializar Planos de Assinatura</h2>
                <p className="description">
                    Clique no botão abaixo para criar os planos de assinatura padrão no Firebase.
                    Isso irá criar 3 planos: Básico, Intermediário e Avançado.
                </p>

                <div className="plans-preview">
                    <div className="preview-card">
                        <span className="preview-icon">🌱</span>
                        <h3>Básico</h3>
                        <p className="preview-price">R$ 29,90/mês</p>
                        <p className="preview-limit">5 pacientes</p>
                    </div>
                    <div className="preview-card">
                        <span className="preview-icon">🚀</span>
                        <h3>Intermediário</h3>
                        <p className="preview-price">R$ 59,90/mês</p>
                        <p className="preview-limit">15 pacientes</p>
                    </div>
                    <div className="preview-card">
                        <span className="preview-icon">👑</span>
                        <h3>Avançado</h3>
                        <p className="preview-price">R$ 99,90/mês</p>
                        <p className="preview-limit">Ilimitado</p>
                    </div>
                </div>

                {message && (
                    <div className={`message message-${status}`}>
                        {message}
                    </div>
                )}

                <button
                    onClick={handleInitialize}
                    disabled={status === 'loading' || status === 'success'}
                    className="btn-initialize"
                >
                    {status === 'loading' ? '⏳ Inicializando...' :
                        status === 'success' ? '✅ Inicializado' :
                            '🚀 Inicializar Planos'}
                </button>
            </div>
        </div>
    );
}
